<template>
    <div>
        <div class="layui-container">
            <div class="view-buy flex-column">
                <h1 class="h1"><img class="image" src="../assets/img/logo5.png" width="77"/>fswan财务软件系统完整源码授权并下载</h1>
                <div class="tips">
                    <p class="buy-tips"><strong>购买者须知：</strong></p>
                    <p class="buy-tips">
                        1、本系统系本公司原创产品，开源版仅供学习和交流，使用必须购买授权，违者必究！
                    </p>
                    <p class="buy-tips">
                        2、购买授权即获取最新前后端全套源码、数据库以及安装部署文档。
                    </p>
                    <p class="buy-tips">
                        3、购买的授权源码100%开放，无任何加密和私服jar包，无域名限制，不限制二次开发。
                    </p>
                    <p class="buy-tips">
                        4、本系统一次授权，终身免费升级更新，授权后可任意修改，自由商用。
                    </p>
                    <p class="buy-tips">
                        5、购买授权版后，如有技术问题可提供远程安装部署帮助和二开指导（远程向日葵或ToDesk，工作日9:00-18:00）（如需安装部署服务请购买
                        <a class="buy-install" target="_blank" @click="handleToggleTab(4)"
                           style="color: #01aaed;cursor: pointer">安装服务</a>）
                    </p>
                </div>
                <div class="buy-er">
                    <p>
                        最新授权版本：<span style="color: #777">v2.1，</span>
                        最近更新时间：<span style="color: #777">2024-06-12</span>
                    </p>
                </div>
                <div class="buy-price">
                    <span class="res-txt">原价</span>
                    <span class="res">￥{{form1001.line_price}}</span>
                    <span class="res-txt">，</span>
                    <span class="dis-txt">限时特惠</span>
                    <span class="dis">￥{{form1001.price}}</span>
                    <div class="time-left" style="color: #00acac">（支付后即可获取下载链接）</div>
                    <div class="time-left" v-if="form1001.isOrderPay">
                        <a style="color: #5567ff;float: right;cursor: pointer" href="javascript:;"
                           @click="downloadedFile()">
                            点击下载源码{{form1001.version}}
                            <svg t="1692866540069" class="icon" viewBox="0 0 1228 1024" version="1.1"
                                 xmlns="http://www.w3.org/2000/svg" p-id="5729" width="30" height="20">
                                <path d="M907.127467 352.6656a7.031467 7.031467 0 0 0 1.706666-7.645867 6.7584 6.7584 0 0 0-6.212266-4.5056h-187.528534l0.477867-318.805333a20.8896 20.8896 0 0 0-6.007467-14.813867 19.319467 19.319467 0 0 0-14.336-6.144H511.863467a19.524267 19.524267 0 0 0-14.336 6.144 21.162667 21.162667 0 0 0-5.870934 14.813867l0.4096 318.805333H304.469333a6.5536 6.5536 0 0 0-6.212266 4.5056 6.826667 6.826667 0 0 0 1.706666 7.645867L589.824 632.149333a19.524267 19.524267 0 0 0 27.4432 0l289.792-279.483733z"
                                      fill="#1296db" p-id="5730"></path>
                                <path d="M1197.397333 701.2352L1015.671467 555.144533a78.984533 78.984533 0 0 0-42.461867-15.1552h-105.198933l175.104 181.4528h-174.557867L779.6736 852.7872H429.806933L344.6784 721.442133H170.052267L344.132267 540.125867h-107.178667c-13.038933 0-32.1536 6.826667-42.461867 15.1552L12.6976 701.2352a38.912 38.912 0 0 0-11.332267 38.570667l72.4992 230.741333c4.096 12.834133 18.090667 23.415467 31.197867 23.415467H1106.602667a34.952533 34.952533 0 0 0 31.061333-23.552l71.2704-230.536534a39.253333 39.253333 0 0 0-11.537067-38.638933"
                                      fill="#1296db" p-id="5731"></path>
                            </svg>
                        </a>
                    </div>
                </div>
                <ul class="flex-row">
                    <li class="buy-blue buy-now hidden" @click="buySubmit('1002');">
                        <p>￥{{form1002.price}}安装服务</p>
                        <a class="txt" href="javascript:;">{{form1002.g_name}}</a>
                    </li>
                    <li class="back-buy buy-now" @click="buySubmit('1001');">
                        <p>获取授权</p>
                        <a class="txt" href="javascript:;">{{form1001.g_name}}</a>
                    </li>
                </ul>
            </div>

            <div class="buy-table buy-table">
                <h2 class="func">fswan各版本功能对比</h2>
                <table class="layui-table" lay-filter="parse-table-demo">
                    <thead>
                    <tr>
                        <td class="head">功能项</td>
                        <td class="head">开源版</td>
                        <td class="head">授权版</td>
                        <td class="head">定制版</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>远程安装指导帮助</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>安装部署说明文档</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>是否最新版源码</td>
                        <td><span class="no-func">×否</span></td>
                        <td><span class="has-func">√是</span></td>
                        <td><span class="has-func">√是</span></td>
                    </tr>
                    <tr>
                        <td>是否最新版架构</td>
                        <td><span class="no-func">×否</span></td>
                        <td><span class="has-func">√是</span></td>
                        <td><span class="has-func">√是</span></td>
                    </tr>
                    <tr>
                        <td>定制性功能</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>凭证管理</td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>科目管理</td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>科目余额表</td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>明细账</td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>初始余额</td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>系统管理</td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>结账功能</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>辅助核算</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>凭证打印</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>报表功能</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>凭证汇总功能</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    <tr>
                        <td>技术支持</td>
                        <td><span class="no-func">×无</span></td>
                        <td><span class="has-func">√有</span></td>
                        <td><span class="has-func">√有</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <el-dialog
                    class="pdiv"
                    title="请使用微信扫码支付"
                    @close='dialogVisible = false'
                    :visible="dialogVisible"
                    width="32%">
                <div class="to-pay" id="toPay" style="text-align: center">
                    <div class="pay-amount" style="font-size: 16px;font-weight: bold">
                        微信支付：<span style="font-size: 20px;color: red;" id="payAmount">￥{{price}}</span>
                    </div>
                    <img style="border-radius: 3px;" ref="payImg" src="" width="200"/>
                    <div class="h5-tips none">长按此二维码识别</div>
                    <div class="op" style="margin-top: 10px">
                        <button @click="payOver();" class="layui-btn">支付完成</button>
                        <p style="color: red;font-size: 13.6px;">（提示：支付成功即可获取相关下载链接 {{installMsg}}）</p>
                    </div>
                </div>
            </el-dialog>

        </div>
    </div>

</template>

<script>
    export default {
        name: "",
        props: {},
        data() {
            return {
                dialogVisible: false,
                price: '',
                installMsg: '',
                form1001: { //含全套源码 + 部署文档
                    isOrderPay: false,
                    version: '',
                    price: '',
                    line_price: '',
                    g_name: '含全套源码 + 部署文档'
                },
                form1002: { //含全套源码 + 部署文档 + 安装服务
                    isOrderPay: false,
                    version: '',
                    price: '',
                    line_price: '',
                    g_name: '含全套源码 + 部署文档 + 安装服务'
                }
            };
        },
        methods: {
            handleToggleTab(id) {
                this.$emit('handleToggleTab', id);
            },
            payOver() {
                this.getGoods('1001');
                this.getGoods('1002');
                this.dialogVisible = false
            },
            getGoods(orderType) {
                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/getGoods',
                    data: {"orderType": orderType}
                }).then(res => {
                    if (res.data.code == 0) {
                        if ('1001' == orderType) {
                            this.form1001 = res.data.data;
                        } else if ('1002' == orderType) {
                            this.form1002 = res.data.data;
                        }
                    }
                });
            },
            buySubmit(orderType) {

                if ('1001' == orderType) {
                    this.price = this.form1001.price;
                    this.installMsg = '';
                } else if ('1002' == orderType) {
                    this.price = this.form1002.price;
                    this.installMsg = '，技术人员稍后会联系您！';
                }

                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/submitOrder',
                    data: {"orderType": orderType},
                    responseType: 'blob'
                }).then(res => {
                    this.dialogVisible = true;
                    this.$nextTick(() => {
                        let img = this.$refs.payImg;
                        let url = window.URL.createObjectURL(res.data);
                        img.src = url;
                    })
                });
            },
            downloadedFile() {
                this.$http({
                    method: 'post',
                    url: '/hapi/mhWeb/webOne/dProject',
                    responseType: 'blob'
                }).then(res => {
                    //通过返回的二进制流创建 Blob对象
                    const url = window.URL.createObjectURL(
                        new Blob([res.data], {type: "application/zip"})
                    );
                    let a = document.createElement('a')//创建一个a标签元素
                    a.style.display = 'none'//设置为不显示
                    a.href = url    //设置a标签的href属性
                    a.setAttribute('download', 'fswan' + this.form1001.version + '源码.zip')//设置下载的文件名
                    document.body.appendChild(a)//将a标签元素加入到页面中
                    a.click()//触发点击
                    document.body.removeChild(a) // 下载完成移除元素
                    window.URL.revokeObjectURL(url) // 释放掉blob对象

                }).finally(r => {
                })
            }
        },
        created() {
            this.getGoods('1001');
            this.getGoods('1002');
        }
    };
</script>

<style scoped>
    .pdiv >>> .el-dialog__body {
        padding: 10px 16px 15px 16px;
    }
</style>